import script from "./Room.vue?vue&type=script&setup=true&lang=js"
export * from "./Room.vue?vue&type=script&setup=true&lang=js"

import "./Room.vue?vue&type=style&index=0&id=39e174aa&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e174aa"]])

export default __exports__